import { clearableDateSchema } from '@bos/form';
import { z } from 'zod';

import { BANK_INCEPTION_DATE, TODAYS_DATE } from '../../constants';

type CreateDateSchemaWithDefinedMinAndMaxBankValuesParams = {
	minDateErrorMessage?: string;
	maxDateErrorMessage?: string;
};

export const createDateSchemaWithDefinedMinAndMaxBankValues = ({
	minDateErrorMessage,
	maxDateErrorMessage,
}: CreateDateSchemaWithDefinedMinAndMaxBankValuesParams) =>
	clearableDateSchema(
		z.coerce
			.date()
			.min(BANK_INCEPTION_DATE, {
				message: minDateErrorMessage,
			})
			.max(TODAYS_DATE, {
				message: maxDateErrorMessage,
			}),
	);
